var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2552.293,
    height: 758.792,
    viewBox: "0 0 2552.293 758.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(-37 359.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1964.272,621.468c-491,136.25-1029.357-181.1-1520.354-317.352S-490.713,212.718.284,76.468,1486.029-74.32,1977.026,61.93,2455.269,485.218,1964.272,621.468Z",
    transform: "translate(250.333 -255.747)",
    fill: "#00a859",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1964.272,621.468c-491,136.25-1029.357-181.1-1520.354-317.352S-490.713,212.718.284,76.468,1486.029-74.32,1977.026,61.93,2455.269,485.218,1964.272,621.468Z",
    transform: "translate(250.333 -326.513)",
    fill: "#1cb16b",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarimg);
export default __webpack_public_path__ + "static/media/navbarimg.58948f7a78d9b9ee9210ec480e880e25.svg";
export { ForwardRef as ReactComponent };